export const getOwner = async (metalordNFTManagerContract) => {
  return await metalordNFTManagerContract.owner()
}

export const createNewNftContract = async (metalordNFTManagerContract, name, symbol) => {
  return await metalordNFTManagerContract.createNewNFTContract(name, symbol)
}

export const mintNFT = async (metalordNFTManagerContract, nftContractAddress, recipientAddress, numberOfToken) => {
  return await metalordNFTManagerContract.mintNFT(nftContractAddress, recipientAddress, numberOfToken)
}

export const metalordNFTsDetail = async (metalordNFTManagerContract, nftContractAddress) => {
  return await metalordNFTManagerContract.metalordNFTsDetail(nftContractAddress)
}

export const allMetalordNFTContractsDeployed = async (metalordNFTManagerContract, index) => {
  return await metalordNFTManagerContract.allMetalordNFTContractsDeployed(index)
}

export const platformData = async (metaspaceNFTMarketplaceContract) => {
  return await metaspaceNFTMarketplaceContract.platformData()
}

export const getCurrencyVolumeTraded = async (metaspaceNFTMarketplaceContract, currency) => {
  return await metaspaceNFTMarketplaceContract.getCurrencyVolumeTraded(currency)
}

export const getTotalFeesCollected = async (metaspaceNFTMarketplaceContract, currency) => {
  return await metaspaceNFTMarketplaceContract.getTotalFeesCollected(currency)
}
